type DashType = {
  size?: number;
};

const Dash = ({ size = 8 }: DashType) => (
  <span
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: size,
      width: size,
    }}
  >
    <span
      style={{
        backgroundColor: "#000",
        height: "1px",
        width: size,
      }}
    />
  </span>
);

export default Dash;
